import { GlobalContextProvider } from "@aleksundshantu/aunds-utils-react/contexts";
import { Section } from "@/components/Section/Section";
import { HeadMeta } from "@/components/Header/Head";
import { FadeIn } from "@/components/Animation";
import { AnimatedHeadline } from "@/components/AnimatedHeadline/AnimatedHeadline";
import { Footer } from "@/components/Footer/Footer";
import { Navbar, NavbarOptionType } from "@/components/Navbar/Navbar";
import { Post } from "@/wp/types/client";
import { MenuType } from "@/types/baseTypes";
import { IconsType } from "@/types/ModuleOptionsType";
import {
  LabelsType,
  OptionsFooterType,
  OptionsSearchType,
  OptionsSecurityHeader,
  OptionsSeoSettingsType,
  OptionsSocialMediaType,
  OptionsViernullvierType,
} from "@/types/OptionType";
import styles from "./NotFoundPage.module.scss";

export interface NotFoundPageProps {
  options?: OptionsViernullvierType;
  post: Post;
  labels: LabelsType;
  icons: IconsType;
  securityHeaderOptions: OptionsSecurityHeader;
  seoSettingsOptions: OptionsSeoSettingsType;
  mainMenu: MenuType;
  footerMenu: MenuType;
  legalMenu: MenuType;
  socialMedia: OptionsSocialMediaType;
  footerOptions: OptionsFooterType;
  navbarOption: NavbarOptionType;
  searchOptions?: OptionsSearchType;
  isNobleElements: boolean;
}

export function NotFoundPage({
  options,
  post,
  labels,
  icons,
  securityHeaderOptions,
  seoSettingsOptions,
  mainMenu,
  footerMenu,
  legalMenu,
  socialMedia,
  footerOptions,
  navbarOption,
  searchOptions,
  isNobleElements,
}: NotFoundPageProps) {
  const { animated_headline, link_404, link_404_aria_label } = options || {};

  return (
    <GlobalContextProvider iconsRaw={icons} labelsRaw={labels}>
      <HeadMeta
        post={post}
        securityHeaderOptions={securityHeaderOptions}
        seoSettingsOptions={seoSettingsOptions}
      />
      <Navbar
        searchPageSlug={searchOptions?.search_page_link || ""}
        menu={mainMenu}
        socialMedia={socialMedia.platforms}
        navbarOption={navbarOption}
        pageData={post}
        isHome={false}
        isPage={true}
        isTextHeader={false}
        isNobleElements={isNobleElements}
      />
      <main id="home">
        <FadeIn>
          <Section
            className={`page404 has-whitebg-bg ${styles["page404"]}`}
            columnsClassName="is-multiline"
            containerClassName="has-text-centered is-small"
          >
            <div className="column is-flex is-12 is-flex-direction-column is-align-items-center">
              <p className={styles["overline"]}>404</p>
              <AnimatedHeadline
                headline={animated_headline?.headline || ""}
                elements={animated_headline?.elements || []}
                link_404={link_404}
                link_404_aria_label={link_404_aria_label}
              />
            </div>
          </Section>
        </FadeIn>
      </main>
      <Footer
        autoShowConsentManagement={
          "header_seite" in post.acf
            ? post.acf?.header_seite?.show_consent_management
            : undefined
        }
        footerOptions={footerOptions}
        socialMedia={socialMedia}
        footerMenu={footerMenu}
        legalMenu={legalMenu}
      />
    </GlobalContextProvider>
  );
}
